import "./professionalBio.css";

const TiffanyCookKingProfessionalJourney = (
  <div className="professional-journey">
    <p>
      Licensed Master Social Worker:
      <br />
      <strong>
        Georgia Composite Board of Professional Counselors, Social Workers, and
        Marriage &amp; Family Therapists
      </strong>
      <br />
      <br />
      EMDR Trained Therapist
      <br />
      <br />
      Somatic-Polyvagal Informed
      <br />
      <br />
      Master of Science in Social Administration, Adult Mental Health
      Concentration: <br />
      <strong>Case Western Reserve University</strong>
      <br />
      <br />
      Bachelor of Social Work: <br />
      <strong>Shaw University</strong>
      <br />
      <br />
    </p>
  </div>
);

export default TiffanyCookKingProfessionalJourney;